import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FacturaPage } from '../factura/factura';
import { Http } from '@angular/http';


@IonicPage()
@Component({
  selector: 'page-pago',
  templateUrl: 'pago.html',
})
export class PagoPage {
  mCompra;
  zona;
  mPago;
  vista;
  user;
  constructor(public navCtrl: NavController, public navParams: NavParams,public http: Http) {
    this.user = JSON.parse(localStorage.getItem('user')).CODIGO_USER;
    this.http.get("http://ebenlovequickpc.com/API/verCar.php?cl=selectOn&codigoUser="+this.user).subscribe((data)=>{
    if(data.json().length > 0){
        this.vista = 'repago';
      }else{
        this.vista = 'pago';
      }
    })
  }

  ionViewDidLoad() {
  }

  facturar(){
    this.navCtrl.push(FacturaPage, {METODO_COMPRA: this.mCompra, ZONA_ENVIO: this.zona, METODO_PAGO: this.mPago, vista: this.vista});
  }

}



// WEBPACK FOOTER //
// ./src/pages/pago/pago.ts